import * as React from 'react'
import { api } from '../lib/api'
import Card from '@mui/joy/Card'
import Button from '@mui/joy/Button'
import Textarea from '@mui/joy/Textarea'
export default function Messages() {
  const [threads, setThreads] = React.useState<any[]>([])
  const [sel, setSel] = React.useState<any | null>(null)
  const [msgs, setMsgs] = React.useState<any[]>([])
  const [text, setText] = React.useState('')
  React.useEffect(() => {
    api('/dm/threads').then(setThreads)
  }, [])
  const open = async (t: any) => {
    setSel(t)
    setMsgs(await api(`/dm/threads/${t.id}/messages`))
  }
  const send = async () => {
    if (!sel) return
    await api(`/dm/threads/${sel.id}/messages`, {
      method: 'POST',
      body: JSON.stringify({ contentMd: text }),
    })
    setText('')
    open(sel)
  }
  return (
    <div className="max-w-6xl mx-auto p-6 grid md:grid-cols-3 gap-4">
      <Card variant="outlined" className="p-0">
        {threads.map((t) => (
          <div
            key={t.id}
            className={
              'px-4 py-3 border-b cursor-pointer ' + (sel?.id === t.id ? 'bg-blue-50' : '')
            }
            onClick={() => open(t)}
          >
            {t.subject || 'Conversation'}
          </div>
        ))}
      </Card>
      <Card variant="outlined" className="md:col-span-2">
        {sel ? (
          <div className="flex flex-col h-[60vh]">
            <div className="flex-1 overflow-auto space-y-2">
              {msgs.map((m) => (
                <div
                  key={m.id}
                  className={
                    m.senderUserId === JSON.parse(localStorage.getItem('user') || '{}').id
                      ? 'text-right'
                      : ''
                  }
                >
                  <span className="inline-block px-3 py-2 rounded-2xl bg-zinc-200 dark:bg-zinc-800">
                    {m.contentMd}
                  </span>
                </div>
              ))}
            </div>
            <div className="mt-3 flex gap-2">
              <Textarea
                value={text}
                onChange={(e) => setText((e.target as any).value)}
                placeholder="Write a message…"
              />
              <Button onClick={send}>Send</Button>
            </div>
          </div>
        ) : (
          <div className="p-4">Select a thread</div>
        )}
      </Card>
    </div>
  )
}
